import { acceptHMRUpdate, defineStore, storeToRefs } from 'pinia'
import { useNotificationFilterStore } from './notificationFilterStore'
import { useNotificationQuery } from './composables/useNotification'
import { useAuthSiteStore } from '../user/authSiteStore'
import { computed } from 'vue'
import { Pagination } from '../common/models/pagination'
import { Notification } from './models/notification'

export const useNotificationStore = defineStore(
    'NotificationStore',
    () => {
        const authSiteStore = useAuthSiteStore()
        const { current } = storeToRefs(authSiteStore)
        const site = computed(() => current.value)

        const filterStore = useNotificationFilterStore()
        const { perPage, page } = storeToRefs(filterStore)

        // A fetching (all queries) state is indicated to users through the filter component.
        // There is no loading (no data queried OR ready yet) state indicator currently.
        const { data, error } = useNotificationQuery(site.value?.id ?? null, { perPage, page })

        const notifications = computed<Notification[]>(() => data.value?.notifications ?? [])
        const pagination = computed<Pagination>(() => data.value?.pagination ?? Pagination.default())

        return {
            notifications,
            pagination,
            error,
        }
    },
)

if (import.meta.hot !== null && import.meta.hot !== undefined) {
    import.meta.hot.accept(
        acceptHMRUpdate(
            useNotificationStore,
            import.meta.hot,
        ),
    )
}
